import { render, staticRenderFns } from "./ActivePlan.vue?vue&type=template&id=6f97de71&scoped=true&"
import script from "./ActivePlan.vue?vue&type=script&lang=js&"
export * from "./ActivePlan.vue?vue&type=script&lang=js&"
import style0 from "./ActivePlan.vue?vue&type=style&index=0&id=6f97de71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97de71",
  null
  
)

export default component.exports